module.exports = __webpack_public_path__ + "static/media/image-stole-leaked.a63ba1a4.png";